export class ProductPassword extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.onSubmit.bind(this),
    )
  }

  onSubmit (event) {
    event.preventDefault()

    const value = this.els.input.element.value.toLowerCase()
    const password = this.dataset.password.toLowerCase()

    this.showResult(value === password)

    if (value === password) {
      this.hideInput()
      setTimeout(() => {
        this.hideButton()
      }, 2000)
      this.hideBIS()
      this.showForms()
    } else {
      setTimeout(() => {
        this.resetResult()
      }, 2500)
    }
  }

  resetResult () {
    const button = this.els.button.element
    const classCorrect = 'prd-Password_Button-correct'
    const classIncorrect = 'prd-Password_Button-incorrect'

    const buttonText = this.els.button_text.element
    const textDefault = this.dataset.default

    button.classList.remove(classCorrect)
    button.classList.remove(classIncorrect)

    buttonText.innerText = textDefault
  }

  showResult (status) {
    const button = this.els.button.element
    const classCorrect = 'prd-Password_Button-correct'
    const classIncorrect = 'prd-Password_Button-incorrect'
    const classAdd = status ? classCorrect : classIncorrect

    const buttonText = this.els.button_text.element
    const textCorrect = this.dataset.success
    const textIncorrect = this.dataset.error
    const textAdd = status ? textCorrect : textIncorrect

    button.classList.remove(classCorrect)
    button.classList.remove(classIncorrect)
    button.classList.add(classAdd)

    buttonText.innerText = textAdd
  }

  hideButton () {
    this.els.button.element.ariaHidden = true
  }

  hideInput () {
    this.els.input.element.ariaHidden = true
  }

  hideBIS () {
    this.externalEls.signup.element.ariaHidden = true
  }

  showForms () {
    this.externalEls.form.elements.forEach(element => {
      element.ariaHidden = false
    })
  }
}

if (!customElements.get('password-form')) {
  customElements.define('password-form', ProductPassword)
}
